<template>
  <div class="dispose">
    <div class="projectname">
      <div class="name">项目名称 :</div>
        <template v-if="itemList.length > 0">
        <div class="project" :class="{show:openProject}" ref="proheight">
          <span :class="['details',{'active':index === itemIndex}]" v-for="(item, index) in itemList" :key="index" @click="choItem(index, item.id, item.title)"  ref="element">{{item.title}}</span>
        </div>
        <div v-if="openExtend" class="open" @click="project">展开<i class="el-icon-arrow-down el-icon--right" :class="{show:openProject}"></i></div>
        </template>
    </div>
    <div class="title">日期配置</div>
    <div class="tables">
      <h3>每月周期表</h3>
      <p>系统将按每月周期表实时推送资源给对应的人员</p>
      <div class="day">
        <div class="days" v-for="(item,index) in dayArr" :key="index" :class="{'active': item.status}" @click.stop="arrange(index)">
          {{item.day}}
          <span v-show="whiceDay === index"></span>
        </div>
      </div>
    </div>
    <div class="main">
      <div class="top">
        <el-button type="text" @click="schedul"><b><i class="el-icon-circle-plus-outline"></i>本地添加人员</b></el-button>
        <el-button type="text" @click="copymoban"><i class="icon-div"></i>复制模版</el-button>
        <el-button type="text" @click="showSetTime"><i class="icon-time"></i>批量设置分配时间</el-button>
        <el-button type="text" @click="showSetGroup"><i class="icon-group"></i>批量设置小组</el-button>
      </div>
      <div class="searchItem">
        <el-input class="searchValue" @keyup.enter.native="searchListItem" v-model="searchItemValue" placeholder="姓名/部门" type="text" size="small"/>
        <el-button class="searchBtn" @click="searchListItem">查询</el-button>
        <div style="float:right">
          <el-button type="danger" @click="delList">删除列表</el-button>
          <el-button type="primary" @click="saveList">保存列表</el-button>
        </div>
      </div>
      <div class="content">
        <el-table
          :data="tableData"
          ref="dragTable"
          highlight-current-row
          row-key="id"
          @selection-change="handleSelectionChange"
          :row-class-name="tableRowClassName">
          <el-table-column type="selection"width="45">
          </el-table-column>
          <el-table-column width="40">
            <i class="el-icon-s-unfold"></i>
          </el-table-column>
          <el-table-column type="index" label="序号" align="center">
          </el-table-column>
          <el-table-column prop="userName" label="姓名">
            <template slot="header">姓名
              <el-tooltip content="人员排序靠前先获得资源" placement="top" popper-class="cons">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
          </el-table-column>
          <el-table-column prop="phone" label="手机">
          </el-table-column>
          <el-table-column prop="deptName" label="部门">
          </el-table-column>
          <el-table-column prop="acceptGroupId" label="小组">
            <template slot="header">小组
              <el-tooltip content="设置小组可以按指定条件分配资源" placement="top" popper-class="cons">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-select v-model="scope.row.acceptGroupId" clearable placeholder="请选择">
                <el-option v-for="(item,index) in groupList" :key="index" :label="item.name" :value="item.id"></el-option>
              </el-select>
            </template>
          </el-table-column>
          <el-table-column prop="dataNum" label="每轮资源获得（条）">
            <template slot="header">每轮资源获得（条）
              <el-tooltip content="0、空代表不分配" placement="top" popper-class="cons">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input
                type="number"
                class="input-new-tag"
                v-if="scope.row.inputVisible === 1"
                v-model="scope.row.dataNum"
                size="small"
                @blur="handleInputConfirm(scope.$index, 'data')"
                @keyup.enter.native="handleInputConfirm(scope.$index, 'data')"
                v-focus
                ref="inputRef">
              </el-input>
              <div v-else class="button-new-div" size="small" >
                {{scope.row.dataNum}}
                <i class="el-icon-edit-outline" @click="showInput(scope.$index, 'data')"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="timeStr" label="分配时间">
            <template slot="header">分配时间
              <el-tooltip content="空代表不限" placement="top" popper-class="cons">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <div class="button-new-div" size="small" >
                <div v-for="item in scope.row.timeStr.split(' ')">{{item}}</div>
                <span class="editTime" @click="editItemDate(scope.row.timeStr, scope.$index)">编辑</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column prop="dataNumLimit" label="每日上限条数">
            <template slot="header">每日上限条数
              <el-tooltip content="0代表不分配，空代表不限" placement="top" popper-class="cons">
                <i class="el-icon-warning-outline"></i>
              </el-tooltip>
            </template>
            <template slot-scope="scope">
              <el-input
                type="number"
                class="input-new-tag"
                v-if="scope.row.limitVisible === 1"
                v-model="scope.row.dataNumLimit"
                size="small"
                @blur="handleInputConfirm(scope.$index, 'limit')"
                @keyup.enter.native="handleInputConfirm(scope.$index, 'limit')"
                v-focus
                ref="inputRef">
              </el-input>
              <div v-else class="button-new-div" size="small" >
                <template v-if="scope.row.dataNumLimit === null || scope.row.dataNumLimit ===''">
                  不限
                </template>
                <template v-else>{{scope.row.dataNumLimit}}</template>
                <i class="el-icon-edit-outline" @click="showInput(scope.$index, 'limit')"></i>
              </div>
            </template>
          </el-table-column>
          <el-table-column label="操作">
            <template slot-scope="scope">
              <!-- <el-button @click.native.prevent="handleClick(scope.$index, scope.row)" type="text" size="small">复制</el-button> -->
              <el-button type="text" size="small" @click.native.prevent="deleteRow(scope.$index, tableData)">删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
    <div class="copy" v-show="closeCopy">
      <div class="copys"></div>
      <div class="c-template">
        <h3 @click="closeCp"><span></span></h3>
        <h4>复制模版</h4>
        <div class="day">
          <div class="days" v-for="(item,index) in dayArr" :key="index" :class="{'active': item.status}" @click.stop="copyArrange(index)">
            {{item.day}}
            <span v-show="item.copyStatus"></span>
          </div>
        </div>
        <div class="text"><i class="el-icon-warning-outline"></i>保存成功后，该日期的数据会覆盖到指定日期</div>
        <div class="btn">
          <el-button @click="saveCopy" :disabled="disabled">保存</el-button>
          <el-button @click="closeCp">取消</el-button>
        </div>
      </div>
    </div>
    <div class="addbeings" v-show="closeAdd">
      <div class="backer"></div>
      <div class="beings">
        <h3 @click="closebacker"><span></span></h3>
        <h4>请选择需要添加的数据</h4>
        <div class="beings-main" style="height:auto;">
          <div class="searchItem searchStaff">
            <el-input class="searchValue" @keyup.enter.native="searchStaffItem" v-model="searchStaffValue" placeholder="姓名" type="text" size="small"/>
            <el-button class="searchBtn1" @click="searchStaffItem">查询</el-button>
          </div>
        </div>
        <div class="beings-main">
          <el-tree
            :data="staffList"
            show-checkbox
            node-key="id"
            highlight-current
            ref="tree"
            :props="{children: 'list',label: 'name'}"
            :filter-node-method="filterStaffNode">
          </el-tree>
        </div>
        <div class="btns">
          <el-button @click="synchro">同步crm人员</el-button>
          <el-button @click="showFileModel">批量添加人员</el-button>
          <el-button @click="saveAdd">保存</el-button>
        </div>
      </div>
    </div>
    <div class="addbeings" v-show="dateModel">
      <div class="backer"></div>
      <div class="beings">
        <h3 @click="closebacker"><span></span></h3>
        <h4>分配时间</h4>
        <div class="addDate-main">
          选择时间：
          <input type="text" readonly placeholder="选择时间" id="setTime" v-model="addTime">
          <!-- <el-time-picker
            is-range
            v-model="addTime"
            value-format="HH:mm"
            range-separator="至"
            start-placeholder="开始时间"
            end-placeholder="结束时间"
            placeholder="选择时间范围">
          </el-time-picker> -->
          <!-- <span class="timeBtn" @click="fnAddTime">添加</span> -->
          <div class="timeBox">
            <span v-for="(item,index) in allocatTime" :key="index" @click="delTime(index)" v-if="item!==''">
                <i class="el-icon-close"></i>
                {{item}}
            </span>
          </div>
        </div>
        <div class="btns">
          <el-button @click="saveEditTime">确定</el-button>
        </div>
      </div>
    </div>
    <div class="addbeings" v-show="groupModel">
      <div class="backer"></div>
      <div class="beings">
        <h3 @click="closebacker"><span></span></h3>
        <h4>分配小组</h4>
        <div class="addDate-main">
          小组名称：
          <el-select v-model="acceptGroupId" clearable placeholder="请选择">
            <el-option v-for="(item,index) in groupList" :key="index" :label="item.name" :value="item.id"></el-option>
          </el-select>
        </div>
        <div class="btns">
          <el-button @click="editGroup">小组管理</el-button>
          <el-button @click="saveSetGroup">保存</el-button>
        </div>
      </div>
    </div>
    <el-dialog
      title="小组管理"
      center
      align = "center"
      :visible.sync="dialogGroupManage"
      width="40%"
      :close-on-click-modal="false">
      <p v-for="(item,index) in editGroupList">
        <el-input v-model="item.name" style="width:40%" autocomplete="off"></el-input>
        <span @click="removeGroup(index)" class="removeGroupBtn">删除</span>
      </p>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addGroup">添 加</el-button>
        <el-button type="primary" @click="saveAddGroup">确 定</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="导入人员"
      center
      align = "center"
      :visible.sync="dialogFileModel"
      width="30%"
      :close-on-click-modal="false">
      <div class="fileModel">
        <p><span>日期：</span> {{fileJson.date}}号</p>
        <p><span>项目名称：</span> {{fileJson.itemName}}</p>
        <p><span>上传文件：</span> <input id="file" type="file" accept="file/xls,file/xlsx" name="file" @change="onFileChange"/></p>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="downloadFile">下载excel模板</el-button>
        <el-button type="primary" @click="submitFile">保 存</el-button>
        <p class="tip">*保存之后会覆盖已有排班数据</p>
      </span>
    </el-dialog>
    <el-dialog
      title="导入人员"
      center
      align = "center"
      :visible.sync="dialogReFileModel"
      width="30%"
      :close-on-click-modal="false">
      <div class="reFileModel">
        <h6>发现同名人员，请确认导入的人员：</h6>
        <el-checkbox-group v-model="checkedReName" @change="handleCheckedReNameChange">
          <el-checkbox v-for="(item,index) in repeatForm.repeatList" :label="index" :key="index">
            <span class="name">{{item.userName}}</span>
            <span>{{item.account}}</span>
          </el-checkbox>
        </el-checkbox-group>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitReNameFile">保 存</el-button>
        <p class="tip">*同名人员全不选系统则默认第一个人</p>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Sortable from 'sortablejs'
import Api from '@/api/client/data-dispose'
export default {
  data () {
    return {
      disabled: false,
      crmCode: 'ec',
      checkedReName: [],
      repeatForm: {},
      dayArr: [],
      arrangeArr: [],
      addTime: '',
      allocatTime: [],
      editItemIndex: '',
      whiceDay: '',
      dialogReFileModel: false,
      dialogFileModel: false,
      fileJson: {},
      dateModel: false,
      groupModel: false,
      groupManageModel: false,
      dialogGroupManage: false,
      acceptGroupId: '',
      visible: false,
      closeCopy: false,
      closeAdd: false,
      delAll: false,
      itemList: [],
      itemIndex: '',
      itemId: '',
      openExtend: false,
      openProject: true,
      tableData: [],
      staffList: [],
      chooseArr: [],
      noChoData: [],
      groupList: [],
      editGroupList: [],
      searchItemValue: '',
      searchStaffValue: '',
      laydate: window.laydate
    }
  },
  created () {
    this.crmCode = this.$router.currentRoute.params.type
    this.getItem()
    this.getExists()
    this.getGroup()
  },
  methods: {
    tableRowClassName (row, index) {
      if (!row.row.status) {
        return 'hidden-row'
      }
      return ''
    },
    searchStaffItem () {
      this.$refs.tree.filter(this.searchStaffValue)
    },
    filterStaffNode (value, data) {
      if (!value) return true
      return data.name.indexOf(value) !== -1
    },
    searchListItem () {
      const list = this.tableData
      const data = this.searchItemValue
      if (data === '') {
        for (let i = 0; i < list.length; i++) {
          list[i].status = true
        }
        return
      }
      for (let i = 0; i < list.length; i++) {
        const userName = list[i].userName
        const deptName = list[i].deptName
        if (userName.indexOf(data) > -1 || deptName.indexOf(data) > -1) {
          list[i].status = true
        } else {
          list[i].status = false
        }
      }
    },
    getGroup () {
      Api.getGroupList(response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.groupList = body.list
        } else {
          this.groupList = []
          this.$message.error(body.error)
        }
      })
    },
    // 获取批量选择的item
    handleSelectionChange (val) {
      let chooseArr = []
      val.forEach((val, index) => {
        this.tableData.forEach((v, i) => {
          if (val.id === v.id) {
            chooseArr.push(i)
          }
        })
      })
      this.chooseArr = chooseArr
    },
    // 删除所选择的时间
    delTime (index) {
      this.allocatTime.splice(index, 1)
    },
    // 获取所选择的时间
    fnAddTime () {
      const time = this.addTime
      if (time === '') {
        this.$message.error('开始时间不能大于结束时间')
        return
      }
      const timeStr = this.addTime.replace(/\s*/g, '')
      this.allocatTime.push(timeStr)
      this.addTime = ''
    },
    // 单个时间分配（显示）
    editItemDate (date, index) {
      if (date !== null) {
        this.allocatTime = date.split(' ')
      } else {
        this.allocatTime = []
      }
      this.editItemIndex = index
      this.dateModel = true
    },
    // 批量时间分配（显示）
    showSetTime () {
      if (this.chooseArr.length === 0) {
        this.$message.error('请先选择需要设置的数据')
        return
      }
      this.editItemIndex = ''
      this.allocatTime = []
      this.dateModel = true
    },
    // 批量设置小组（显示）
    showSetGroup () {
      if (this.chooseArr.length === 0) {
        this.$message.error('请先选择需要设置的数据')
        return
      }
      this.editItemIndex = ''
      this.groupModel = true
    },
    showGroupModel () {
      this.groupManageModel = true
    },
    editGroup () {
      this.dialogGroupManage = true
      this.editGroupList = []
      this.editGroupList = JSON.parse(JSON.stringify(this.groupList))
    },
    removeGroup (index) {
      this.$confirm('确定要删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.editGroupList.splice(index, 1)
      }).catch(() => {})
    },
    addGroup () {
      const form = {
        name: '',
        id: ''
      }
      this.editGroupList.push(form)
    },
    // 提交时间分配（显示）
    saveEditTime () {
      let addTimeStr = ''
      for (let i = 0; i < this.allocatTime.length; i++) {
        if (i === this.allocatTime.length - 1) {
          addTimeStr += this.allocatTime[i]
        } else {
          addTimeStr += this.allocatTime[i] + ' '
        }
      }
      const list = this.tableData
      if (this.editItemIndex !== '') {
        list[this.editItemIndex].timeStr = addTimeStr
      } else {
        this.chooseArr.forEach((i) => {
          list[i].timeStr = addTimeStr
        })
      }
      this.closebacker()
    },
    saveSetGroup () {
      const list = this.tableData
      this.chooseArr.forEach((i) => {
        list[i].acceptGroupId = this.acceptGroupId
      })
      this.closebacker()
    },
    saveAddGroup () {
      const form = this.editGroupList
      Api.saveAddGroup(form, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.$message.success('提交成功')
          this.dialogGroupManage = false
          this.getGroup()
        } else {
          this.$message.error(body.error)
        }
      })
    },
    // 同步CRM人员
    synchro () {
      const crmCode = {
        crmCode: this.crmCode
      }
      Api.synchro(crmCode, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.$message.success('同步成功！')
        } else {
          this.$message.error(body.error)
        }
      })
    },
    // 获取用户项目名称
    getItem () {
      Api.getItem(response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.itemList = body.list
        } else {
          this.itemList = []
          this.$message.error(body.error)
        }
      })
    },
    // 查询已配置日期列表
    getExists () {
      const form = {
        itemsId: this.itemId,
        crmCode: this.crmCode
      }
      Api.getExists(form, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.arrangeArr = body
          let dayArr = []
          for (let i = 1; i <= 31; i++) {
            let dayJson = {day: '', status: false, copyStatus: false}
            dayJson.day = i
            for (let k = 0; k <= body.length; k++) {
              if (i === body[k]) {
                dayJson.status = true
              }
            }
            dayArr.push(dayJson)
          }
          this.dayArr = dayArr
          let isArrage = false
          for (let i = 0; i <= this.arrangeArr.length; i++) {
            if (this.arrangeArr[i] === this.whiceDay + 1) {
              isArrage = true
            }
          }
          // 判断该日期是否排班
          if (!isArrage) {
            // this.$message.error('该日期尚未排班')
            this.tableData = []
          } else {
            this.getArrageList()
          }
        } else {
          this.$message.error(body.error)
        }
      })
    },
    arrange (day) {
      if (this.whiceDay === day) {
        return
      }
      this.whiceDay = day
      this.fileJson.date = day + 1
      if (this.itemIndex !== '') {
        this.getArrageList()
      }
    },
    // 选择项目名称
    choItem (index, itemId, itemTitle) {
      this.itemIndex = index
      this.itemId = itemId
      this.fileJson.itemId = itemId
      this.fileJson.itemName = itemTitle
      this.getExists()
    },
    // 获取列表数据
    getArrageList () {
      const date = this.whiceDay + 1
      const itemId = this.itemId
      let isArrage = false
      for (let i = 0; i <= this.arrangeArr.length; i++) {
        if (this.arrangeArr[i] === this.whiceDay + 1) {
          isArrage = true
        }
      }
      // 判断该日期是否排班
      if (!isArrage) {
        this.$message.error('该日期尚未排班')
        this.tableData = []
        return
      }
      const crmCode = {
        crmCode: this.crmCode
      }
      Api.dateArrange(crmCode, date, itemId, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          body.forEach(item => {
            item.inputVisible = 0
            item.limitVisible = 0
          })
          this.tableData = body
        } else {
          this.tableData = []
          this.$message.error(body.error)
        }
      })
    },
    copyArrange (index) {
      const status = !this.dayArr[index].copyStatus
      this.$set(this.dayArr[index], 'copyStatus', status)
    },
    // 打开复制模版
    copymoban () {
      let isArrage = false
      for (let i = 0; i <= this.arrangeArr.length; i++) {
        if (this.arrangeArr[i] === this.whiceDay + 1) {
          isArrage = true
        }
      }
      if (this.arrangeArr.length === 0) {
        this.$message.error('暂未有已排班的日期，请先排班')
      } else if (this.whiceDay === '') {
        this.$message.error('请在上面选择已排班的日期')
      } else if (!isArrage) {
        this.$message.error('该日期尚未排班，请选择已排班的日期')
      } else {
        this.closeCopy = true
      }
    },
    // 保存复制模版
    saveCopy () {
      let copyArr = []
      for (let i = 0; i < this.dayArr.length; i++) {
        if (this.dayArr[i].copyStatus) {
          copyArr.push(this.dayArr[i].day)
        }
      }
      if (copyArr.length === 0) {
        this.$message.error('请选择需要复制该模板的日期')
      } else {
        this.disabled = true
        let form = {}
        form.date = this.whiceDay + 1
        form.dateList = copyArr
        form.crmCode = this.crmCode
        Api.copyList(form, response => {
          this.disabled = false
          let status = response.status || 0
          let body = response.data || []
          if (status === 200 || status === 204) {
            this.getExists()
            this.closeCp()
            this.$message.success('复制成功')
          } else {
            this.tableData = []
            this.$message.error(body.error)
          }
        })
      }
    },
    // 导入人员
    showFileModel () {
      if (this.itemList.length === 0) {
        this.$message.error('当前没有项目，不能排班')
      } else if (this.whiceDay === '') {
        this.$message.error('请在上面选择要排班的日期')
      } else if (this.itemIndex === '') {
        this.$message.error('请先选择项目')
      } else {
        this.dialogFileModel = true
      }
    },
    onFileChange (e) {
      this.fileJson.file = e.target.files[0]
    },
    submitFile () {
      let form = this.fileJson
      form.crmCode = this.crmCode
      Api.saveFiles(form, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          if (body.repeatList.length === 0) {
            this.$message.success('导入成功！')
            this.arrangeArr.push(form.date)
            this.getExists()
            this.getArrageList()
            this.dialogFileModel = false
          } else {
            this.dialogReFileModel = true
            this.repeatForm = body
          }
          // this.$message.success('保存成功！')
        } else {
          this.$message.error(body.error)
        }
      })
    },
    submitReNameFile () {
      const data = JSON.parse(JSON.stringify(this.repeatForm.repeatList))
      const choItem = this.checkedReName
      const list = []
      for (let i = 0; i < choItem.length; i++) {
        const index = choItem[i]
        list.push(data[index])
      }
      const form = {
        repeatList: list,
        slot: this.repeatForm.slot,
        crmCode: this.crmCode
      }
      Api.saveReName(form, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.dialogReFileModel = false
          this.dialogFileModel = false
          this.$message.success('保存成功！')
          this.checkedReName = []
          this.arrangeArr.push(this.whiceDay + 1)
          this.getExists()
          this.getArrageList()
          this.closeAdd = false
        } else {
          this.$message.error(body.error)
        }
      })
    },
    // 下载ecxel模板
    downloadFile () {
      window.location.href = '/rest/es/dailyarrange/getFormTemplate'
    },
    // 本地添加人员
    schedul () {
      if (this.itemList.length === 0) {
        this.$message.error('当前没有项目，不能排班')
      } else if (this.whiceDay === '') {
        this.$message.error('请在上面选择要排班的日期')
      } else if (this.itemIndex === '') {
        this.$message.error('请先选择项目')
      } else {
        this.getStaffList()
      }
    },
    // 获取人员
    getStaffList () {
      const date = this.whiceDay + 1
      const itemId = this.itemId
      const crmCode = {
        crmCode: this.crmCode
      }
      Api.getStaffList(crmCode, date, itemId, response => {
        let status = response.status || 0
        let body = response.data || []
        if (status === 200 || status === 204) {
          this.staffList = body.map.depts
          this.closeAdd = true
        } else {
          this.staffList = []
          this.$message.error(body.error)
        }
      })
    },
    saveAdd () {
      let noUser = false
      let userId = ''
      const tree = this.$refs.tree.getCheckedNodes()
      for (var i = 0; i < tree.length; i++) {
        if (tree[i].list.length === 0) {
          if (tree[i].aBoolean === 1) {
            const choUserId = tree[i].id
            userId += choUserId + ','
          } else {
            noUser = true
          }
        }
      }
      userId = userId.substring(0, userId.length - 1)
      if (userId === '') {
        if (noUser) {
          this.$message.error('没有可添加人员')
        } else {
          this.$message.error('请先选择排班人员')
        }
        return
      }
      let form = {}
      form.date = this.whiceDay + 1
      form.itemId = this.itemId
      form.userId = userId
      form.crmCode = this.crmCode
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.addStaff(form, response => {
        let status = response.status || 0
        let body = response.data || []
        loading.close()
        if (status === 200 || status === 204) {
          this.arrangeArr.push(form.date)
          this.getExists()
          this.getArrageList()
          this.$message.success('保存成功！')
          this.closebacker()
        } else {
          this.$message.error(body.error)
        }
      })
    },
    // 保存列表
    saveList () {
      if (this.delAll) {
        this.delListUrl()
        return
      }
      this.tableData.forEach(item => {
        delete item.inputVisible
        delete item.limitVisible
      })
      const form = this.tableData
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.savelist(form, response => {
        let status = response.status || 0
        let body = response.data || []
        loading.close()
        if (status === 200 || status === 204) {
          this.getArrageList()
          this.$message.success('保存成功！')
        } else {
          this.$message.error(body.error)
        }
      })
    },
    // 删除列表
    delList () {
      if (this.tableData.length === 0) {
        this.$message.error('暂无数据可删')
        return false
      }
      this.$confirm('确定要删除该项目的当天数据吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.delListUrl()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    delListUrl () {
      const date = this.whiceDay + 1
      const itemId = this.itemId
      const crmCode = {
        crmCode: this.crmCode
      }
      const loading = this.$loading({
        lock: true,
        text: '保存中...',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)'
      })
      Api.dellist(crmCode, date, itemId, response => {
        let status = response.status || 0
        let body = response.data || []
        loading.close()
        if (status === 200 || status === 204) {
          this.getExists()
          this.tableData = []
          if (this.delAll) {
            this.$message.success('保存成功！')
          } else {
            this.$message.success('删除成功！')
          }
          this.delAll = false
        } else {
          this.$message.error(body.error)
        }
      })
    },
    // 拖动功能
    setSort () {
      const el = this.$refs.dragTable.$el.querySelectorAll('.el-table__body-wrapper > table > tbody')[0]
      this.sortable = Sortable.create(el, {
        ghostClass: 'sortable-ghost',
        setData: function (dataTransfer) {
          dataTransfer.setData('Text', '')
        },
        onEnd: evt => {
          const targetRow = this.tableData.splice(evt.oldIndex, 1)[0]
          this.tableData.splice(evt.newIndex, 0, targetRow)
        }
      })
    },
    // 复制功能
    handleClick (index, e) {
      const copy = {
        createTime: null,
        creater: '',
        crmCode: this.crmCode,
        dataNum: null,
        date: '',
        deptId: '',
        deptName: '',
        id: '',
        itemsId: '',
        itemsTitle: '',
        phone: '',
        sort: 0,
        userId: '',
        userName: '',
        wyCustomerId: ''
      }
      copy.creater = e.creater
      copy.dataNum = e.dataNum
      copy.dataNumLimit = e.dataNumLimit
      copy.date = e.date
      copy.deptId = e.deptId
      copy.deptName = e.deptName
      copy.id = ''
      copy.itemsId = e.itemsId
      copy.itemsTitle = e.itemsTitle
      copy.phone = e.phone
      copy.sort = this.tableData.length
      copy.userId = e.userId
      copy.userName = e.userName
      copy.wyCustomerId = e.wyCustomerId
      copy.inputVisible = 0
      copy.limitVisible = 0
      copy.timeStr = e.timeStr
      copy.status = true
      this.tableData.push(copy)
    },
    // 删除行功能
    deleteRow (index, rows) {
      this.$confirm('确定要删除吗?', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        rows.splice(index, 1)
        if (rows.length === 0) {
          this.delAll = true
        }
      })
    },
    showInput (index, type) {
      if (type === 'limit') {
        this.tableData[index].limitVisible = 1
      } else {
        this.tableData[index].inputVisible = 1
      }
    },
    // 失去焦点或回车执行
    handleInputConfirm (index, type) {
      if (type === 'limit') {
        this.tableData[index].limitVisible = 0
      } else {
        this.tableData[index].inputVisible = 0
      }
    },
    // 关闭复制模版
    closeCp () {
      this.closeCopy = false
      this.dateModel = false
    },
    // 关闭添加数据模版
    closebacker () {
      this.closeAdd = false
      this.dateModel = false
      this.groupModel = false
    },
    // 展开项目功能
    project () {
      this.openProject = !this.openProject
    },
    // 根据高度判断项目扩展高度
    extend () {
      let proheight = this.$refs.proheight.offsetHeight
      let height = this.$refs.element[0].offsetHeight
      if (proheight > height) {
        this.openExtend = true
      } else {
        this.openExtend = false
      }
    }
  },
  mounted () {
    this.setSort()
    setTimeout(this.extend, 800)
    this.laydate.render({
      elem: '#setTime',
      type: 'time',
      range: true,
      done: (value, start, end) => {
        const date = new Date()
        const month = date.getMonth() + 1
        const startTime = new Date(date.getFullYear() + '-' + month + '-' + date.getDate() + ' ' + start.hours + ':' + start.minutes + ':' + start.seconds).getTime()
        const endTime = new Date(date.getFullYear() + '-' + month + '-' + date.getDate() + ' ' + end.hours + ':' + end.minutes + ':' + end.seconds).getTime()
        if (startTime >= endTime) {
          this.$message.error('结束时间不能小于开始时间')
          document.getElementById('setTime').value = ''
          this.addTime = ''
          return false
        }
        this.addTime = value
        const timeStr = this.addTime.replace(/\s*/g, '')
        this.allocatTime.push(timeStr)
      }
    })
  },
  // 自动获取
  directives: {
    focus: {
      // 指令的定义
      inserted: function (el) {
        el.querySelector('input').focus()
      }
    }
  }
}
</script>

<style lang="scss">
.content{
  .hidden-row{
    display: none;
  }
}
#setTime{
  width:300px;
  height:35px;
  border:1px solid rgba(208,208,208,1);
  border-radius:2px;
  padding-left:5px;
  box-sizing: border-box;
}
.layui-laydate .layui-this{
  background-color: #085ECC!important;
}
.dispose .el-dialog__title{
  color: #085ECC;
  font-size: 18px;
  font-weight: bold;
  text-align: center;
  margin-top: 22px;
  margin-bottom: 40px;
}
.searchItem{
  margin:32px 0 20px;
  &.searchStaff{
    margin:0 0 20px;
  }
  .searchValue{
    width:290px;
    height:40px;
    box-sizing: border-box;
    .el-input__inner{
      height:40px;
      line-height: 40px;
    }
  }
  .searchBtn1{
    background:rgba(74,152,255,1);
    color:rgba(255,255,255,1);
  }
  .searchBtn{
    width:94px;
    height:40px;
    background:#454545;
    border-radius:4px;
    padding:0;
    box-sizing: border-box;
    color:#FFFFFF;
    font-size: 14px;
    margin-left:20px;
  }
}
.reFileModel{
  width:300px;
  margin:0 auto;
  color:#333333;
  text-align:center;
  .el-checkbox__input{
    position:relative;
    top:2px;
  }
  .el-checkbox{
    margin-right:0;
    margin-bottom:10px;
  }
  h6{
    font-size:16px;
    font-weight:600;
    color:rgba(51,51,51,1);
    margin:0 0 30px;
  }
  span{
    float:left;
    font-size:15px;
    font-weight:600;
    color:rgba(102,102,102,1);
  }
  .name{
    width:60px;
    text-align:left;
  }
}
</style>

<style scoped="scoped" lang="scss">
  .tip{
    font-size:14px;
    color:red;
  }
  .fileModel{
    width:300px;
    margin:0 auto;
    color:#333333;
    span{
      width:80px;
      text-align:right!important;
      display: inline-block;
      font-weight:bold;
    }
    input{
      width:60%;
    }
  }
  .removeGroupBtn {
    margin-left: 5px;
    cursor: pointer;
  }
  .dispose{
    min-height: 1010px;
    background: white;
    padding: 20px 28px 50px 28px;
    box-sizing: border-box;
    border: 1px solid #e0e0e0;
    .title{
      color: #085ECC;
      font-size: 16px;
      font-weight: bold;
      position: relative;
      left: 14px;
      top: 2px;
    }
    .title::after{
      content: "";
      display: block;
      width: 2px;
      height: 16px;
      background: #085ECC;
      position: absolute;
      left: -12px;
      top: 3.5px;
    }
    .projectname{
      background:#FCFCFC;
      border:1px solid #EBEEF5;
      line-height: 43px;
      padding-left: 15px;
      margin-bottom: 24px;
      overflow: hidden;
      font-size: 14px;
      box-sizing: border-box;
      > div{
        float: left;
      }
      .name{
        color: #000;
        font-weight: 600;
        margin-right: 10px;
      }
      .project{
        width: 82%;
        overflow: hidden;
        min-height: 43px;
        max-height: 43px;
        height: auto;
        transition: max-height ease-out .81s;
        .details{
          cursor: pointer;
          padding: 0 25px;
          color: #333;
          float: left;
          &.active{
            color:#085ECC;
          }
        }
      }
      .show{
        max-height: 999px;
        transition: max-height ease-in 1s;
      }
      > .open{
        float: right;
        cursor: pointer;
        color: #085ECC;
        .show{
          transition: all .3s;
          transform: rotate(180deg);
          -ms-transform:rotate(180deg); 	/* IE 9 */
          -moz-transform:rotate(180deg); 	/* Firefox */
          -webkit-transform:rotate(180deg); /* Safari 和 Chrome */
          -o-transform:rotate(180deg); 	/* Opera */
        }
      }
    }
    .tables{
      text-align: center;
      > h3{
        font-size: 24px;
        margin-bottom: 0;
        margin-top: 31px;
        color: #085ECC;
        font-size: 18px;
        font-weight: bold;
      }
      > p{
        font-size: 14px;
        color: #999;
        margin-top: 11px;
        margin-bottom: 19px;
      }
      .day{
        width: 564px;
        margin: 0 auto 25px;
        .days{
          width: 78px;
          height: 60px;
          border-right: 1px solid #EBEEF5;
          border-top: 1px solid #EBEEF5;
          float: left;
          color: #333;
          cursor: pointer;
          font-size: 14px;
          text-align: left;
          padding: 8px 0 0 10px;
          box-sizing: border-box;
          position: relative;
          span{
            display: block;
            background: url(../../../assets/images/tick.png);
            width: 17px;
            height: 13px;
            position: absolute;
            bottom: 7px;
            right: 6px;
          }
        }
        .days:nth-child(1),.days:nth-child(8),.days:nth-child(15),.days:nth-child(22),.days:nth-child(29){
          border-left: 1px solid #EBEEF5;
        }
        .days:nth-last-child(1),.days:nth-last-child(2),.days:nth-last-child(3),.days:nth-last-child(4),.days:nth-last-child(5),.days:nth-last-child(6),.days:nth-last-child(7){
          border-bottom: 1px solid #EBEEF5;
        }
        .active{
          color: #0296f7;
          background-color: #F2F8FE;
        }
      }
      .day:after{
        content: "";
        display: block;
        clear: both;
      }
    }
    .main{
      width: 96%;
      position: relative;
      margin-top: 45px;
      .top{
        height: 64px;
        line-height: 64px;
        background:rgba(236,248,255,.6);
        position: relative;
        .icon-div{
          width: 19px;
          height: 19px;
          background-size: 100%;
          display: inline-block;
          background: url(../../../../static/images/div_01.png) no-repeat;
          background-size: contain;
          vertical-align: bottom;
        }
        .icon-group{
          width: 20px;
          height: 20px;
          background-size: 100%;
          display: inline-block;
          vertical-align: bottom;
          background: url(../../../../static/images/div_02.png) no-repeat;
          background-size: contain;
        }
        .icon-time{
          width: 20px;
          height: 20px;
          background-size: 100%;
          display: inline-block;
          vertical-align: bottom;
          background: url(../../../../static/images/div_03.png) no-repeat;
          background-size: contain;
        }
      }
      .top::after{
        content: "";
        display: block;
        position: absolute;
        height: 100%;
        width: 5px;
        background:rgba(80,191,255,.6);
        left: 0;
        top: 0;
        border-radius:3px 0px 0px 3px;
      }

      .content{
        .el-icon-s-unfold{
          font-size: 20px;
          cursor: pointer;
        }
      }
      .visible{
        width: 100%;
        height: 100%;
        position: fixed;
        left: 0;
        top: 0;
      }
    }
    .copy{
      .copys{
        background:#000;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        opacity: .5;
      }
      .c-template{
        width:770px;
        background-color: #FFF;
        opacity: 1;
        z-index: 20;
        position: fixed;
        top: 50%;
        transform: translate(-50%,-50%);
        left: 50%;
        > h3{
          margin: 0;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 18px;
          top: 18px;
          z-index: 21;
          cursor: pointer;
          > span{
            display: block;
            position: relative;
            width: 16px;
            height: 2px;
            background-color: #666;
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 8px;
          }
          > span:after{
            content: "";
            display: block;
            width: 16px;
            height: 2px;
            background-color: #666;
            -webkit-transform: rotate(270deg);
            -moz-transform: rotate(270deg);
            -o-transform: rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: rotate(270deg);
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        > h4{
          color: #085ECC;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-top: 22px;
        }
        .day{
          width: 564px;
          margin: 43px auto 19px;
          .days{
            width: 78px;
            height: 60px;
            border-right: 1px solid #EBEEF5;
            border-top: 1px solid #EBEEF5;
            float: left;
            color: #333;
            cursor: pointer;
            font-size: 14px;
            text-align: left;
            padding: 8px 0 0 10px;
            box-sizing: border-box;
            position: relative;
            > span{
              display: block;
              background: url(../../../assets/images/tick.png);
              width: 17px;
              height: 13px;
              position: absolute;
              bottom: 7px;
              right: 6px;
            }
          }
          .days:nth-child(1),.days:nth-child(8),.days:nth-child(15),.days:nth-child(22),.days:nth-child(29){
            border-left: 1px solid #EBEEF5;
          }
          .days:nth-last-child(1),.days:nth-last-child(2),.days:nth-last-child(3),.days:nth-last-child(4),.days:nth-last-child(5),.days:nth-last-child(6),.days:nth-last-child(7){
            border-bottom: 1px solid #EBEEF5;
          }
          .active{
            color: #0296f7;
            background-color: #F2F8FE;
          }
        }
        .day::after{
          content:".";
          display:block;
          height:0;
          clear:both;
          visibility:hidden;
        }
        > .text{
          color: #737373;
          font-size: 14px;
          width: 564px;
          margin: 0 auto;
          > i{
            margin-right: 5px;
          }
        }
        > .btn{
          text-align: center;
          margin: 61px 0 47px;
          > button{
            width: 100px;
            height: 32px;
            line-height: 0;
          }
          > button:first-child{
            background-color: #085ECC;
            color: #fff;
          }
        }
      }
    }
    .addbeings{
      .timeBox{
        width: 51%;
        margin: 10px auto;
        text-align: left;
        padding-left: 84px;
        box-sizing: border-box;
        span{
          background:#fff;
          border:1px solid rgba(8,94,204,1);
          opacity:0.6;
          border-radius:10px;
          font-size:12px;
          font-weight:500;
          color:rgba(8,94,204,1);
          opacity:0.7;
          padding:1px 10px;
          display: inline-block;
          margin-right:7px;
          margin-bottom:8px;
          cursor: pointer;
          i{
            opacity: 1;
            font-weight: bold;
          }
        }
      }
      .backer{
        background-color: #000;
        width: 100vw;
        height: 100vh;
        position: fixed;
        top: 0;
        left: 0;
        opacity: .5;
        z-index: 1;
      }
      .beings{
        width:750px;
        height:500px;
        background-color: #fff;
        opacity: 1;
        z-index: 20;
        position: fixed;
        top: 50%;
        left: 50%;
        margin-left: -375px;
        margin-top: -243px;
        > h3{
          margin: 0;
          width: 20px;
          height: 20px;
          position: absolute;
          right: 18px;
          top: 18px;
          z-index: 21;
          cursor: pointer;
          > span{
            display: block;
            position: relative;
            width: 16px;
            height: 2px;
            background-color: #666;
            -webkit-transform: rotate(45deg);
            -moz-transform: rotate(45deg);
            -o-transform: rotate(45deg);
            -ms-transform: rotate(45deg);
            transform: rotate(45deg);
            top: 8px;
          }
          > span:after{
            content: "";
            display: block;
            width: 16px;
            height: 2px;
            background-color: #666;
            -webkit-transform: rotate(270deg);
            -moz-transform: rotate(270deg);
            -o-transform: rotate(270deg);
            -ms-transform: rotate(270deg);
            transform: rotate(270deg);
            position: absolute;
            top: 0;
            left: 0;
          }
        }
        > h4{
          color: #085ECC;
          font-size: 18px;
          font-weight: bold;
          text-align: center;
          margin-top: 22px;
          margin-bottom: 40px;
        }
        .addDate-main{
          margin:100px auto;
          text-align: center;
          color: #085ECC;
          .timeBtn{
            cursor: pointer;
          }
        }
        .beings-main{
          height: 280px;
          width: 400px;
          margin: 0 auto;
          overflow-y: auto;
        }
        > .btns{
          text-align: center;
          > button{
            width: 120px;
            height: 40px;
            line-height: 0;
            background-color: #085ECC;
            color: #fff;
          }
          > button:nth-child(1){
            // background-color: #454547;
          }
        }
      }
    }
  }
</style>
<style lang="scss">
  .dispose {
    .el-table{
      border-top:1px solid #EBEEF5;
    }
    .top {
      padding-left: 30px;
      > .el-button--text{
        margin-right: 18px;
        > span{
          color: #666;
          font-family: 'Microsoft YaHei';
          font-size: 16px;
          font-weight: 400;
          b{
            color:#000;
            font-weight: 600;
          }
          i{
            font-size: 19px;
            position: relative;
            top:1px;
            font-weight:600;
            right:3px;
          }
        }
      }
      > .el-button{
        margin-left: 0;
      }
      > .el-button--danger,.el-button--primary{
        width: 94px;
        height: 40px;
      }
    }
  }


  .content{
    > .el-table{
      td{
        > .cell{
          color: #666;
          > .button-new-div{
            color: #666;
            font-size: 14px;
            > i{
              font-size: 18px;
            }
          }
          .input-new-tag{
            width: 70px;
            .el-input__inner{
              width: 70px;
              height: 23px;
              line-height: 23px;
            }
          }
        }
      }
      .editTime{
        font-size:14px;
        font-weight:400;
        color:rgba(8,94,204,1);
        cursor: pointer;
      }
      th{
        background-color: #fff;
        > div{
          font-weight: bold;
          color: #333;
        }
      }
    }
    .el-table__header{
      .el-tooltip{
        position: relative;
        top: -4px;
        z-index: 3;
      }
      .cons{
        background: red!important;
      }
    }
    > .el-table::before{
      height: 0;
    }
    .el-table__row .cell{
      .el-icon-edit-outline{
        font-size: 16px;
        cursor: pointer;
        vertical-align: middle;
      }
    }
    .el-table__footer-wrapper, .el-table__header-wrapper{
      padding: 6px 0;
    }
  }
</style>





// WEBPACK FOOTER //
// src/components/client/crm/Datadispose.vue